module.exports = __webpack_public_path__ + "img/29e475ccaeeb4cd2d321411ab5dbabf8.png";